export default __webpack_public_path__ + "static/media/footer-m@2x.7d6006be.png";